/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Monthly_DescriptionInputs */

const en_pricing_monthly_description = /** @type {(inputs: Pricing_Monthly_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full access, one month at a time.`)
};

const es_pricing_monthly_description = /** @type {(inputs: Pricing_Monthly_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso completo, mes a mes.`)
};

/**
* | output |
* | --- |
* | "Full access, one month at a time." |
*
* @param {Pricing_Monthly_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_monthly_description = /** @type {((inputs?: Pricing_Monthly_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Monthly_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_monthly_description(inputs)
	return en_pricing_monthly_description(inputs)
});